import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { SectionsProvider } from '../../providers/Articles/Sections/SectionsProvider';
import { AgentsCategoriesProvider } from '../../providers/Agents/AgentsCategories/AgentsCategoriesProvider';
import { AgentsTermsProvider } from '../../providers/Agents/Terms/AgentsTermsProvider';
import { SubsectionsProvider } from '../../providers/Articles/Subsections/SubsectionsProvider';
import { ArticlesProvider } from '../../providers/Articles/ArticlesProvider';
import { ArticleCommentProvider } from '../../providers/Articles/ArticlesCommentsProvider';
import { ArticlesHighlightsProvider } from '../../providers/Articles/ArticlesHighlights/ArticlesHighlightsProvider';
import { ArticleLockProvider } from '../../providers/Articles/ArticlesLocks/ArticlesLocksProvider';
import { TagProvider } from '../../providers/Tags/TagsProvider';
import { FinancialsProvider } from '../../providers/Financial/Financials/FinancialsProvider';
import { FinancialAgentCategoriesProvider } from '../../providers/Financial/FinancialAgentCategories/FinancialAgentCategoriesProvider';

interface Props {
    element?: any;
    path?: string;
}

export const ArticlesRoute: FC<Props> = () => {
    return (
        <AgentsCategoriesProvider>
            <AgentsTermsProvider>
                <SectionsProvider>
                    <SubsectionsProvider>
                        <ArticlesProvider>
                            <ArticleCommentProvider>
                                <ArticlesHighlightsProvider>
                                    <ArticleLockProvider>
                                        <TagProvider>
                                            <FinancialsProvider>
                                                <FinancialAgentCategoriesProvider>
                                                    <Outlet />
                                                </FinancialAgentCategoriesProvider>
                                            </FinancialsProvider>
                                        </TagProvider>
                                    </ArticleLockProvider>
                                </ArticlesHighlightsProvider>
                            </ArticleCommentProvider>
                        </ArticlesProvider>
                    </SubsectionsProvider>
                </SectionsProvider>
            </AgentsTermsProvider>
        </AgentsCategoriesProvider>
    );
}